import 'feather-icons'
import type { App } from 'vue'
import VueFeather from 'vue-feather'

export default function (app: App) {
  app.component(VueFeather.name || 'vue-feather', VueFeather)
}
